import React, { useEffect, useState } from 'react';

export interface DelayedLoadingProps {
  loading: boolean;
  delay?: number;
  children: React.ReactNode;
}

const DelayedLoading: React.FC<DelayedLoadingProps> = ({ loading, delay = 200, children }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!loading) {
      setVisible(false);
      return;
    }

    const timeout = window.setTimeout(() => setVisible(true), delay);
    return () => window.clearTimeout(timeout);
  }, [delay, loading]);

  return loading && visible ? <>{children}</> : null;
};

export default DelayedLoading;
